import React from "react";
import { Dialog, Divider } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { useNavigate } from "react-router-dom";

import SoftBox from "../../components/SoftBox";
import SoftTypography from "../../components/SoftTypography";
import SoftButton from "../../components/SoftButton";
import { useDispatch } from "react-redux";
import { getCompanyUsers } from "../../redux/company/actions";

const BillingUpdate = ({ billingUpdateDialog, closeBillingUpdateDialog }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const okayHandler = () => {
    closeBillingUpdateDialog();
    dispatch(getCompanyUsers());
  };

  return (
    <Dialog
      open={billingUpdateDialog}
      onClose={closeBillingUpdateDialog}
      sx={{
        "& .MuiPaper-root": {
          padding: { mini: "1rem", md: "1.5rem 1.7rem" },
          borderRadius: "24px",
          background:
            "linear-gradient(180deg, rgba(255,255,255,0.70) 0%, rgba(255,255,255,0.60) 100%)",
          boxShadow:
            "0px 24px 48px -8px rgba(16,24,40,0.18), inset 0px 1px 0px 0px rgba(255,255,255,0.7)",
          backdropFilter: "blur(18px) saturate(160%)",
          width: "100%",
          maxWidth: "700px",
          border: "1px solid rgba(255,255,255,0.6)",
        },
      }}
    >
      <SoftBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <SoftTypography variant="h4" sx={{ color: "#0F172A" }}>
          Billing Update
        </SoftTypography>
        <SoftButton
          variant="outlined"
          color="dark"
          onClick={closeBillingUpdateDialog}
          sx={{
            "& svg": { fontSize: "1.25rem !important" },
            borderRadius: "50%",
            minWidth: "max-content",
            minHeight: "max-content",
            padding: "0.25rem",
            color: "#475467",
          }}
        >
          <CloseRoundedIcon />
        </SoftButton>
      </SoftBox>
      <Divider
        sx={{
          backgroundColor: "rgba(15,23,42,0.10)",
        }}
      />
      <SoftBox mb="60px">
        <SoftTypography
          component="p"
          sx={{
            fontWeight: 500,
            color: "#475467",
            fontSize: 16,
            marginBottom: "20px",
          }}
        >
          You've successfully removed a player from your workspace. No worries,
          your billing will be updated accordingly.
        </SoftTypography>
        <SoftTypography
          component="p"
          sx={{
            fontWeight: 500,
            color: "#475467",
            fontSize: 16,
            marginBottom: "20px",
          }}
        >
          Please note that any changes will be reflected in the next billing cycle.
          Feel free to manage your players anytime!
          {/* Remember, you're on our free plan, and any changes will be reflected
          in the next billing cycle. Feel free to manage your players anytime! */}
        </SoftTypography>
        <SoftTypography
          component="p"
          sx={{
            fontWeight: 500,
            color: "#475467",
            fontSize: 16,
            marginBottom: "20px",
          }}
        >
          Keep the game strong! 🚀
        </SoftTypography>
      </SoftBox>
      <SoftBox display="flex" justifyContent="space-between">
        <SoftButton
          color="primary"
          variant="contained"
          onClick={() => navigate("/settings/billing")}
          sx={{
            color: "primary.contrastText",
            textTransform: "none",
            borderRadius: "4px",
          }}
        >
          Go to Billing
        </SoftButton>
        <SoftButton
          color="dark"
          variant="outlined"
          onClick={okayHandler}
          sx={{
            mx: 2,
            textTransform: "none",
            borderRadius: "4px",
            border: "1px solid rgba(15,23,42,0.10)",
            boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
            color: "#475467",
          }}
        >
          Okay
        </SoftButton>
      </SoftBox>
    </Dialog>
  );
};

export default BillingUpdate;
